// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__kLs14","white":"Logo_white__3yPkc"};